import React from "react";

const UnauthorizedPage = () => {
  return (
    <div className="text-center">
      <h1 className="text-2xl font-bold">Unauthorized</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
};

export default UnauthorizedPage;
